import React, { useState } from "react";
import { ToastContainer, toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { useDropzone } from 'react-dropzone'; // Import the dropzone hook
import axios from 'axios';
import Cookies from "js-cookie"
import { motion } from "framer-motion";
import "react-toastify/dist/ReactToastify.css";
import images from "../constants/image.js";
import { Navbar } from "./Navbar.jsx";
import { ClipLoader } from "react-spinners";


const pics = [
  { logo: images.PB1 },
  { logo: images.Uploading },
];
const api=process.env.REACT_APP_API_URL;

const FileUpload=()=> {
  const [currentStep, setCurrentStep] = useState(1);
  const [resumeUploaded, setResumeUploaded] = useState(false);
  const [resumeFile, setResumeFile] = useState(null);
  const [jobDescriptionUploaded, setJobDescriptionUploaded] = useState(false);
  const [jobDescriptionText, setJobDescriptionText] = useState("");
  const [uploadProgress, setUploadProgress] = useState(0);
  const [jobDescriptionFile, setJobDescriptionFile] = useState(null);
  const navigate = useNavigate();
  const [isResumeBlocked, setIsResumeBlocked] = useState(false);
  const [isJobDescriptionBlocked, setIsJobDescriptionBlocked] = useState(false);
  const [loader,setLoader]=useState(false);
  const isValidFileType = (file) => {
    const validTypes = [
        "application/pdf",
        "application/msword",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    ];
    return validTypes.includes(file.type);
};


const handleResumeUpload = (event, userDetails) => {
    
    const accessToken = Cookies.get('access_token');

    if (!accessToken) {
        toast.error("Please log in before uploading your resume.");
        setTimeout(() => navigate("/"), 2000);
        return;
    }

    

    handleFileUpload(event, setResumeUploaded, setResumeFile, () => {
        setTimeout(() => setCurrentStep(2), 1500);
        toast.success("Resume Uploaded Successfully!");
    });
};


const handleJobDescriptionUpload = (event) => {
    handleFileUpload(event, setJobDescriptionUploaded, setJobDescriptionFile, () => {
        toast.success("Job Description Uploaded Successfully!");
    });
};

const handleFileUpload = (event, setUploadedState, setFileState, onSuccess) => {
    const file = event.target.files[0];
    if (file) {
        if (isValidFileType(file)) {
            setUploadedState(true);
            setFileState(file);
            onSuccess();
        } else {
            toast.error("Please upload a valid PDF or Word document.");
            event.target.value = null;
            setUploadedState(false);
        }
    }
};

const handleJobDescriptionTextChange = (event) => {
    const text = event.target.value;
    setJobDescriptionText(text);
    setJobDescriptionUploaded(text.trim().length > 0);
};

const next_page = async () => {
  const formData = new FormData();
  formData.append("resume_file", resumeFile);

  if (jobDescriptionFile) {
    formData.append("jd_file", jobDescriptionFile);
  } else if (jobDescriptionText.trim()) {
    const blob = new Blob([jobDescriptionText], { type: "text/plain" });
    const textFile = new File([blob], "job_description.txt");
    formData.append("jd_file", textFile);
  }

  const token = Cookies.get("access_token"); // Ensure this retrieves the token correctly
  setLoader(true);

  try {
    const response = await axios.post(`${api}analysis/`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${token}`,
      },
      credentials: 'include',
    });

    setLoader(false);

    if (response.status === 200) {
      const responseData = response.data; // Access parsed data directly
      toast.success("Files uploaded successfully!");

      // Update completed steps
      const completedSteps = JSON.parse(localStorage.getItem("completedSteps")) || [];
      if (!completedSteps.includes("upload")) {
        completedSteps.push("upload");
        localStorage.setItem("completedSteps", JSON.stringify(completedSteps));
      }

      // Navigate with state
      navigate("/filesPreview", {
        state: { 
          data: responseData, 
          resumeFile, 
          jobDescriptionFile, 
          jobDescriptionText 
        },
      });
    }
  } catch (error) {
    setLoader(false);
    toast.error("Failed to upload files. Please try again.");
  }
};

  
  const home_page=()=>{
    navigate('/');
  }
  
  
  return (
    <>
    <Navbar />
    { loader ? <div className="flex flex-col justify-center items-center h-screen bg-gray-100">
            <ClipLoader color="#007BFF" size={50} />
            <p>Uploading Files ...</p>
        </div> :
      <div className="min-h-screen relative mt-10 bg-white">
        <div className="mx-auto px-4 sm:px-4 w-auto sm:max-w-7xl">
          <div className="flex justify-between items-center">
            <button className="px-4 py-2 sm:px-4 sm:py-2 rounded-md bg-gray-300 text-white" onClick={home_page}>
              Home
            </button>
            <h1 className="text-xl sm:text-3xl lg:text-4xl sm:font-bold text-center">
              {currentStep === 1 ? "Upload Your Resume" : "Upload Job Description"}
            </h1>
            <button
              className="px-4 py-2 rounded-md bg-gray-600 text-white"
              disabled={!resumeUploaded || !(jobDescriptionUploaded || jobDescriptionFile)}
              onClick={next_page}
            >
              Next
            </button>

          </div>

          {currentStep === 1 && (
            <div className="flex justify-center mt-20">
              <div
                className="relative bg-gray-100/50 rounded-lg border border-gray-300 shadow-lg p-8 flex flex-col justify-center items-center space-y-4 w-96 sm:w-[40rem] lg:w-[60rem] h-80 sm:h-[24rem] lg:h-[30rem]"
                onClick={() => document.getElementById("resumeInput").click()  } 
              >
                <div className="absolute inset-0 border-dotted border-4 border-gray-900 rounded-lg animate-rotate-border"></div>
                <div className="relative z-10 text-center" >
                  <img
                    src="https://res.cloudinary.com/danm2mfq5/image/upload/v1735278408/m4nm4nonpx3jznvfv7qj.png"
                    alt="Upload Icon"
                    className="w-20 h-20 mx-auto"
                  />
                  <h1 className="text-lg sm:text-xl lg:text-2xl font-semibold">
                    Upload Your Resume
                  </h1>
                  <p className="text-gray-600">Files we can read: DOCX, PDF</p>
                  <p className="text-gray-600">
                    {resumeUploaded && resumeFile
                      ? `Uploaded File: ${resumeFile.name}`
                      : ""}
                  </p>

                  <button
                    className="px-4 py-2 mt-4 rounded-md bg-blue-500 text-white hover:bg-blue-600"
                    disabled={isJobDescriptionBlocked} // Disable if Job Description is entered/uploaded
                  >
                    Upload
                  </button>
                  {uploadProgress > 0 && uploadProgress < 100 && (
                    <div className="mt-4 text-blue-500">
                      Uploading: {uploadProgress}%
                    </div>
                  )}
                </div>
              </div>
              <input
                id="resumeInput"
                type="file"
                className="hidden"
                onChange={handleResumeUpload}
                disabled={isJobDescriptionBlocked} // Disable if Job Description is entered/uploaded
              />
            </div>
          )}

          {currentStep === 2 && (
            <motion.div
              className="mt-20 mx-auto"
              initial={{ opacity: 0, x: "100%" }}
              animate={{ opacity: 1, x: "0%" }}
              exit={{ opacity: 0, x: "-100%" }}
              transition={{ duration: 0.5 }}
              key={currentStep}
            >
              <>
                <div className="flex justify-center">
                  <div
                    className="relative bg-gray-100/50 rounded-lg border border-gray-300 shadow-lg p-8 flex flex-col justify-center items-center space-y-4 w-96 sm:w-[40rem] lg:w-[60rem] h-80 sm:h-[24rem] lg:h-[30rem]"
                    onClick={() => document.getElementById("resumeInput").click()} 
                  >
                    <div className="absolute inset-0 border-dotted border-4 border-blue-400 rounded-lg animate-rotate-border"></div>
                    <div className="relative z-10 text-center">
                      <img
                        src="https://res.cloudinary.com/danm2mfq5/image/upload/v1735278408/m4nm4nonpx3jznvfv7qj.png"
                        alt="Upload Icon"
                        className="w-20 h-20 mx-auto"
                      />
                      <h1 className="text-lg sm:text-xl lg:text-2xl font-semibold">
                        Upload Your Job Description
                      </h1>
                      <p className="text-gray-600">Files we can read: DOCX, PDF</p>
                      <p className="text-gray-600">
                        {jobDescriptionUploaded && jobDescriptionFile
                          ? `Uploaded File: ${jobDescriptionFile.name}`
                          : ""}
                      </p>

                      <button
                        className="px-4 py-2 mt-4 rounded-md bg-blue-500 text-white hover:bg-blue-600"
                        disabled={isResumeBlocked} // Disable if Resume is uploaded
                      >
                        Upload
                      </button>
                      {uploadProgress > 0 && uploadProgress < 100 && (
                        <div className="mt-4 text-blue-500">
                          Uploading: {uploadProgress}%
                        </div>
                      )}
                    </div>
                  </div>
                  <input
                    id="resumeInput"
                    type="file"
                    className="hidden"
                    onChange={handleJobDescriptionUpload}
                    disabled={isResumeBlocked} // Disable if Resume is uploaded
                  />
                </div>

                <h1 className="space-y-10 text-center">OR</h1>
                <div className="flex flex-col items-center space-y-10">
                  <textarea
                    className="w-96 sm:w-[40rem] lg:w-[60rem] h-40 sm:h-60 rounded-md border mb-4 border-black-900 shadow-sm p-4 resize-none focus:outline-none focus:ring-2 focus:ring-blue-400"
                    placeholder="Type your job description here..."
                    value={jobDescriptionText}
                    onChange={handleJobDescriptionTextChange}
                    disabled={isResumeBlocked} // Disable if Resume is uploaded
                  ></textarea>
                </div>
              </>

            </motion.div>
          )}
        </div>
      </div>
}
    </>
  );
}

export default FileUpload
